import { lazy } from 'react';

// project imports
import MainLayout from '../layouts/MainLayout';
import Loadable from '../components/Loadable';
import Employees from '../components/Employees';
import Jobs from '../components/Jobs';
import Candidates from '../components/Candidates';
import HRStaff from '../components/HRStaff';
import Onboarding from '../components/Onboarding';
import Offboarding from '../components/Offboarding';
import CreateEmployee from '../components/CreateEmployee';
import Profile from '../pages/Profile/Profile.js';
import ViewProfile from '../components/ViewProfile';
import InactiveViewProfile from '../components/archive/InactiveViewProfile';
import RequestEmployee from '../components/RequestEmployee';
import AddOfficePolicyPage from '../pages/policiesSys/officePoliciesPage/addOfficePolicy';
import UpdateOfficePolicyPage from '../pages/policiesSys/officePoliciesPage/updateOfficePolicy';
import HRHandbookPage from '../pages/policiesSys/hrHandbook';
import AddPolicyPage from '../pages/policiesSys/hrHandbook/addPolicy';
import UpdatePolicyPage from '../pages/policiesSys/hrHandbook/updatePolicy';
import MarabesAboutPage from '../pages/about';
import LeaveRequestPage from '../pages/leavesSys/leaveRequestPage';
import LeavesManagement from '../pages/leavesSys/LeavesManagement.jsx';
import YearCalendar from '../components/calendars/YearCalendar';
import PayrollImpactDashboard from '../pages/Payroll/PayrollImpactDashboard';
import RulesManagement from '../pages/Payroll/RulesManagement';
import AbsenceManagement from '../pages/leavesSys/AbsenceManagement.jsx';
import DocRequestManagement from '../pages/Docs/DocRequestManagement';
import PoliciesManagement from '../pages/policiesSys/policiesManagement.jsx';
import OrganizationalChart from '../charts/orgChart/index.jsx';
import EmployeesManagement from '../pages/Employees/EmployeesManagent.jsx';
import ContractManagement from '../pages/Contracts&Salaries/index';
import OfficeManagement from '../pages/OfficeManagement';
import GoalManagement from '../pages/GoalsManagement.jsx';
import AbsenceKPIDashboard from '../components/KPIDashs/AbsenceKPI.jsx';
import PolicyDetailView from '../components/DViews/PolicyDetailView.jsx';
import Lateness from '../pages/leavesSys/LatenessPage.jsx';
import Personal from '../pages/leavesSys/PersonalPage.jsx';
import Sickness from '../pages/leavesSys/Sickness.jsx';
import Vacation from '../pages/leavesSys/Vacation.jsx';
import AddLateness from '../pages/leavesSys/AddL.jsx';
import AddPersonal from '../pages/leavesSys/AddPC.jsx';
import FillSickness from '../pages/leavesSys/AddS.jsx';
import VacationRequests from '../pages/leavesSys/Requests.jsx';
import VacationRequestsOverview from '../pages/leavesSys/VacationRequestsOverview.jsx';
import AddLeaveRequest from '../pages/leavesSys/AddLeaveRequest.jsx';
import CandidateReportGenerator from '../reports/CandidateReportGenerator.jsx';
import CandidateDetailsReport from '../reports/CandidateDetailsReport.jsx';
import ProbationReviewReport from '../reports/ProbationReviewReport.jsx';
import EmployeeFeedbackReport from '../reports/EmployeeFeedbackReport.jsx';
import ContractRenewalFeedbackReport from '../reports/ContractRenewalFeedbackReport.jsx';
import SalaryReport from '../reports/SalaryReport.jsx';
import EmployeesAttendance from '../reports/EmployeesAttendance.jsx';
import AttendanceReportTable from '../reports/AttendanceReport.jsx';
import UnconfirmedAbsences from '../pages/leavesSys/Unconfirmed.jsx';
import RWeeklyReport from '../reports/WeeklyReport.jsx';
import VacationPlanningReport from '../reports/VacationPlanningReport.jsx';
import ITSupportPage from '../pages/ITSupport.jsx';
import EndpointsInspector from '../pages/DevInfos.jsx';
import NotificationDispatcherPage from '../pages/dev/NotificationDispatcherPage.jsx';
import InactiveEmployees from '../components/archive/InactiveEmployees';
import AlumniGroup from '../components/archive/AlumniGroup';
import AttendanceKPI from '../pages/leavesSys/AttendanceKPIs.jsx';
import Suspension from '../pages/leavesSys/Suspension.jsx';
import AddSuspension from '../pages/leavesSys/AddSus.jsx';
import PolicyViewer from '../pages/op.jsx';
import DayOff from '../pages/leavesSys/DayOff.jsx';
import AddDayOff from '../pages/leavesSys/AddDO.jsx';
import Unknown from '../pages/leavesSys/Unknown';
import HolidayCorrection from '../pages/leavesSys/HolidayCorrection.jsx';
import AddUnknown from '../pages/leavesSys/AddU';
import ProgressTrackerPage from '../pages/progressTracking/ProgressTrackerPage.jsx'
import AdhanTimesPage from '../pages/AdhanPage/AdhanTimesPage';
import MyTeam from '../components/pm/MyTeam';
import TeamMemberProfile from '../components/pm/TeamMemberProfile';

//Protection
import ProtectedRoute from '../utils/ProtectedRoute';
import MyDashboard from '../components/MyDashboard.js';

// Clockwise Timesheet
import Timesheet from '../pages/clockwise/Timesheet';
import TimesheetOverview from '../pages/clockwise/TimesheetOverview';
import EmployeesCareer from '../pages/Employees/EmployeesCareer.jsx';

import MyOvertime from '../pages/leavesSys/MyOvertime.jsx';
import OvertimeManagement from '../pages/leavesSys/OvertimeManagement.jsx';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard/Default')));

// EMPLOYEE
const userRole = localStorage.getItem('userRole');
const IsEmployee = userRole === 'EMPLOYEE';

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <MainLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/dashboard',
      element: <DashboardDefault />
    },
    {
      path: '/progress-tracking',
      element: <ProgressTrackerPage />
    },
    {
      path: '/adhan-times',
      element: <AdhanTimesPage />
    },
    {
      path: '/offices',
      element: <OfficeManagement />
    },
    {
      path: '/goals',
      element: <GoalManagement />
    },
    {
      path: '/dev',
      element: <EndpointsInspector />
    },
    {
      path: '/dev/notifications',
      element: <NotificationDispatcherPage />
    },
    {
      path: '/dev/dispatch-notifications',
      element: <NotificationDispatcherPage />
    },
    {
      path: '/notifications/dispatch',
      element: <NotificationDispatcherPage />
    },
    {
      path: '/kpi',
      element: <AttendanceKPI />
    },
    {
      path: '/vacation',
      element: <Vacation />
    },
    {
      path: '/lateness',
      element: <Lateness />
    },
    {
      path: '/personal',
      element: <Personal />
    },
    {
      path: '/sickness',
      element: <Sickness />
    },
    {
      path: '/day_off',
      element: <DayOff />
    },
    {
      path: '/unknown',
      element: <Unknown />
    },
    {
      path: '/holiday-correction',
      element: <HolidayCorrection />
    },
    {
      path: '/suspension',
      element: <Suspension />
    },
    {
      path: '/unconfirmed',
      element: <UnconfirmedAbsences />
    },
    {
      path: '/sickness/add',
      element: <FillSickness />
    },
    {
      path: '/personal/add',
      element: <AddPersonal />
    },
    {
      path: '/lateness/add',
      element: <AddLateness />
    },
    {
      path: '/suspension/add',
      element: <AddSuspension />
    },
    {
      path: '/day_off/add',
      element: <AddDayOff />
    },
    {
      path: '/unknown/add',
      element: <AddUnknown />
    },
    {
      path: '/vacation-requests',
      element: <VacationRequests />
    },
    {
      path: '/vacation-requests-overview',
      element: <VacationRequestsOverview />
    },
    {
      path: '/employees',
      element: <EmployeesManagement />
    },
    {
      path: '/jobs',
      element: <Jobs />
    },
    {
      path: '/candidates',
      element: <Candidates />
    },
    {
      path: '/hr-staff',
      element: <HRStaff />
    },
    {
      path: '/policies',
      element: <PoliciesManagement />
    },
    {
      path: '/contract',
      element: <ContractManagement />
    },
    {
      path: '/onboarding',
      element: <Onboarding />
    },
    {
      path: '/offboarding',
      element: <Offboarding />
    },
    {
      path: '/requests',
      element: <DocRequestManagement />
    },
    {
      path: '/createemployee',
      element: <CreateEmployee />
    },
    {
      path: '/add-office-policies',
      element: <AddOfficePolicyPage />
    },
    {
      path: '/office-policies/update/:id',
      element: <UpdateOfficePolicyPage />
    },
    {
      path: '/hr-handbook',
      element: <HRHandbookPage />
    },
    {
      path: '/add-policy',
      element: <AddPolicyPage />
    },
    {
      path: '/hr-handbook/update/:id',
      element: <UpdatePolicyPage />
    },
    {
      path: '/leaves',
      element: <LeavesManagement />
    },
    {
      path: '/year-calendar',
      element: <YearCalendar />
    },
    {
      path: '/payroll-impact',
      element: <PayrollImpactDashboard />
    },
    {
      path: '/my-balance',
      element: <RulesManagement />
    },
    {
      path: '/policy-viewer',
      element: <PolicyViewer />
    },
    {
      path: '/absence',
      element: <AbsenceManagement />
    },
    {
      path: '/about',
      element: <MarabesAboutPage />
    },
    {
      path: '/leave-request',
      element: <AddLeaveRequest />
    },
    {
      path: '/profile',
      element: <Profile />
    },
    {
      path: '/view-profile/:id',
      element: <ViewProfile />
    },

    {
      path: '/requestemployee',
      element: <RequestEmployee />
    },
    {
      path: '/it',
      element: <ITSupportPage />
    },
    {
      path: '/mydashboard',
      element: <MyDashboard />
    },
    // Project Manager routes
    {
      path: '/my-team',
      element: <MyTeam />
    },
    {
      path: '/team-profile/:id',
      element: <TeamMemberProfile />
    },
    {
      path: '/chart',
      element: <OrganizationalChart />
    },
    {
      path: '/policies/view',
      element: <PolicyDetailView />
    },
    // Reports
    {
      path: '/reports/candidates',
      element: <CandidateReportGenerator />
    },
    {
      path: '/reports/candidate-details',
      element: <CandidateDetailsReport />
    },
    {
      path: '/reports/probation-reviews',
      element: <ProbationReviewReport />
    },
    {
      path: '/reports/attendance',
      element: <AttendanceReportTable />
    },
    {
      path: '/reports/weekly-report',
      element: <RWeeklyReport />
    },
    {
      path: '/reports/vacation-planning',
      element: <VacationPlanningReport />
    },
    {
      path: '/reports/employee-feedback-report',
      element: <EmployeeFeedbackReport />
    },
    {
      path: '/reports/contract-renewal-feedback',
      element: <ContractRenewalFeedbackReport />
    },
    {
      path: '/reports/salary-report',
      element: <SalaryReport />
    },
    {
      path: '/reports/employees-attendance',
      element: <EmployeesAttendance />
    },
    {
      path: '/inactive-employees',
      element: <InactiveEmployees />
    },
    {
      path: '/alumni-group',
      element: <AlumniGroup />
    },
    {
      path: '/inactive-profile/:id',
      element: <InactiveViewProfile />
    },

    // ── Clockwise Timesheet ──────────────────────────────────────────────────
    {
      path: '/timesheet',
      element: <Timesheet />
    },
    {
      path: '/timesheet/overview',
      element: <TimesheetOverview />
    },
    {
      path: '/employees-career',
      element: <EmployeesCareer />
    },
    {
      path: '/my-overtime',
      element: <MyOvertime />
    },
    {
      path: '/overtime-management',
      element: <OvertimeManagement />
    },
  ]
};

export default MainRoutes;


